import type Employee from '@/stores/Employee'
import type { PbxAppDashboardItemShortcuts } from '@/TcxApi/PbxApp'
import type { PbxPhonebookContact } from '@/TcxApi/PbxPhonebook'

export interface SearchResult {
	/** Score - how important is this result */
	score: number
	/** Type of item in this result */
	type: SearchResultType
	/** Index in list */
	index: number
	/** Item type */
	itemType: SearchResultItemType
	/** Item data */
	item: Employee | PbxPhonebookContact | PbxAppDashboardItemShortcuts['shortcuts'][0] | string
	/** Primary label for search results */
	label: string
	/** Secondary labels for search results */
	fields: string[]
	/** Id of item */
	_id: string
	/** List of phone numbers on the item */
	numbers: SearchResultNumber[]
	/** If item can receive an SMS, this is the number to send to */
	sms?: string
	/** If item can receive an e-mail, this is the e-mail addresss to send to */
	email?: string
}

export interface SearchResultNumber {
	/** Label for search results */
	label: string
	/** Phone number without national prefix */
	number: string
	/** Type of number: HOME, WORK, MOBILE, MAIN, OTHER, DIRECT, EXTENSION */
	type: 'HOME' | 'WORK' | 'MOBILE' | 'MAIN' | 'OTHER' | 'DIRECT' | 'EXTENSION'
}

export enum SearchResultType {
	/** Item is a phone number entered by the user */
	DIRECT = 'DIRECT',
	/** Item is an employee we can call, sms or email */
	EMPLOYEE = 'EMPLOYEE',
	/** Item is a contact from the phonebook */
	PHONEBOOK = 'PHONEBOOK',
	/** Item is a shortcut from a shortcut dashboard panel */
	SHORTCUT = 'SHORTCUT'
}

export enum SearchResultItemType {
	/** item data is an employee */
	EMPLOYEE = 'EMPLOYEE',
	/** Item data is a shortcut */
	SHORTCUT = 'SHORTCUT',
	/** Item data is something else */
	OTHER = 'OTHER'
}

export interface SelectNumberItem {
	label: string
	call: string
	id: number
}
